module.exports = __webpack_public_path__ + "static/media/roti_01.b574d92d.png";